import ProjectScopeDocEditFormComponent from './scope-doc-edit-form.component'

const ProjectScopeDocEditFormModule = angular.module('cdbl.scope-doc-edit-form', [

])
  .component('cdblProjectScopeDocEditForm', ProjectScopeDocEditFormComponent)
  .name

export default ProjectScopeDocEditFormModule
